import { useState } from "react";
import { ActionIcon, Button, List, Modal, Stack, Text, Tooltip } from "@mantine/core";
import { IconDeviceMobileDown, IconDotsVertical, IconShare2 } from "@tabler/icons-react";
import { isAndroid, usePwaInstall } from "../helpers/pwaInstall";

// "App installieren" in the header — shown unless the app already runs
// installed. Opens the browser's install prompt where there is one (Chrome,
// Edge, Samsung), otherwise shows the steps for this device.
export function InstallAppButton() {
  const { mode, promptInstall } = usePwaInstall();
  const [helpOpen, setHelpOpen] = useState(false);

  if (!mode) return null;

  const onClick = () => {
    // Browser install dialog where available, otherwise the manual steps.
    if (mode === "prompt") promptInstall();
    else setHelpOpen(true);
  };

  return (
    <>
      {/* Label on wider screens, icon only on phones (header space is tight) */}
      <Button
        visibleFrom="sm"
        variant="light"
        size="xs"
        leftSection={<IconDeviceMobileDown size={16} />}
        onClick={onClick}
      >
        App installieren
      </Button>
      <Tooltip label="App installieren">
        <ActionIcon hiddenFrom="sm" variant="light" size="xl" onClick={onClick} aria-label="App installieren">
          <IconDeviceMobileDown stroke={1.5} />
        </ActionIcon>
      </Tooltip>

      <Modal
        opened={helpOpen}
        onClose={() => setHelpOpen(false)}
        title={mode === "ios" ? "App auf dem iPhone / iPad installieren" : "App installieren"}
        centered
      >
        <Stack>
          {mode === "ios" ? (
            <List type="ordered" spacing="sm">
              <List.Item>Diese Seite in <b>Safari</b> öffnen.</List.Item>
              <List.Item>
                Unten (iPad: oben) auf <b>Teilen</b> tippen{" "}
                <IconShare2 size={16} style={{ verticalAlign: "text-bottom" }} />.
              </List.Item>
              <List.Item>Nach unten scrollen und <b>„Zum Home-Bildschirm“</b> wählen.</List.Item>
              <List.Item>Mit <b>„Hinzufügen“</b> bestätigen.</List.Item>
            </List>
          ) : isAndroid() ? (
            <List type="ordered" spacing="sm">
              <List.Item>Diese Seite in <b>Chrome</b> (oder Samsung Internet) öffnen – nicht aus WhatsApp o.ä. heraus.</List.Item>
              <List.Item>
                Oben rechts das Menü{" "}
                <IconDotsVertical size={16} style={{ verticalAlign: "text-bottom" }} /> öffnen.
              </List.Item>
              <List.Item><b>„App installieren“</b> bzw. <b>„Zum Startbildschirm hinzufügen“</b> wählen.</List.Item>
            </List>
          ) : (
            <List type="ordered" spacing="sm">
              <List.Item>Diese Seite in <b>Chrome</b> oder <b>Edge</b> öffnen.</List.Item>
              <List.Item>
                Rechts in der Adressleiste auf das Installations-Symbol klicken
                – oder im Menü <b>„App installieren“</b> / <b>„Diese Seite als App installieren“</b> wählen.
              </List.Item>
            </List>
          )}
          <Text size="sm" c="dimmed">
            Danach startest du den ClubManager wie eine App über sein Symbol – im Vollbild, ohne Browserleiste.
          </Text>
          <Button onClick={() => setHelpOpen(false)}>Verstanden</Button>
        </Stack>
      </Modal>
    </>
  );
}
